import { useFields } from "web/hooks/data"
import { useModals } from "web/hooks/modals"

import { Button, Form, Field, useCurrentView } from "web/components"

import { NUMERIC_FIELD_KINDS } from "web/constants"

const NUMERIC_FIELD_TYPES_WITH_DATE = [...NUMERIC_FIELD_KINDS, "Date"]

function Settings({ fields, categoryField, respond }) {
  const nonNumericFields = fields
    .filter((field) => !NUMERIC_FIELD_TYPES_WITH_DATE.includes(field.kind))
    .filter((field) => !field.multiple_values)
    .map((field) => ({ value: field.id, label: field.label }))

  const formValue = {}

  if (!!categoryField) {
    formValue.categoryField = {
      value: categoryField.id,
      label: categoryField.label,
    }
  }

  function handleFormSubmit({ categoryField }) {
    respond({
      categoryFieldId: !!categoryField
        ? fields.find((f) => f.id === categoryField.value).id
        : undefined,
    })
  }

  return (
    <Form
      value={formValue}
      fields={[
        {
          id: "categoryField",
          key: "categoryField",
          name: "categoryField",
          label: "Category Field",
          kind: "Lookup",
          lookup_values: nonNumericFields,
        },
      ]}
      onSubmit={handleFormSubmit}
      render={(form) => {
        return (
          <>
            <div className="modal-content-above-commands">
              <div>
                {form.fields.map((field) => (
                  <Field key={field.id} fieldKey={field.key} />
                ))}
              </div>
            </div>
            <div className="modal-commands">
              <div className="left-buttons">
                <Button onClick={form.submit}>Save Settings</Button>
              </div>
            </div>
          </>
        )
      }}
    />
  )
}

function useMapSettingsModal({ fields }) {
  const { showModal } = useModals()

  return async function (props) {
    return await showModal({
      title: "Map Settings",
      fullScreen: false,
      heightPixels: 400,
      widthPixels: 400,
      component: ({ respond }) => (
        <Settings respond={respond} fields={fields} {...props} />
      ),
    })
  }
}

export default function useMapSettings(subjectType) {
  const fields = useFields({
    subjectType,
    includeMultipleSubjectsFields: subjectType === "deal_asset" ? true : false,
  })

  const { view, handleChangeMapCategory } = useCurrentView()
  const mapSettingsModal = useMapSettingsModal({ fields })

  const categoryField = fields.find((f) => f.id === view.mapCategoryFieldId)

  async function handleChangeSettings() {
    const result = await mapSettingsModal({ categoryField })
    if (!result) return
    handleChangeMapCategory(result.categoryFieldId)
  }

  return { categoryField, handleChangeSettings }
}
